import PatientErrorTable from './PatientError'
import PatientFormTable from './PatientForm'
import PatientResultTable from './PatientResult'
import PatientScheduleTable from './PatientSchedule'
import PatientConfirmationTable from './PatientConfirmation'

export default {
    PatientErrorTable,
    PatientFormTable,
    PatientResultTable,
    PatientScheduleTable,
    PatientConfirmationTable
}
